export default {
  // Navigation
  nav_home: "Home",
  nav_about: "About",
  nav_programs: "Programs",
  nav_admissions: "Admissions",
  nav_research: "Research",
  nav_partnerships: "Partnerships",
  nav_campus: "Campus",
  nav_news: "News",
  nav_contact: "Contact",
  nav_apply: "Apply Now",
  nav_lang_fr: "FR",
  nav_lang_en: "EN",

  // Hero
  // Home Hero Card
  hero_card_intro: "Located at the Palais des Congrès in Yaoundé, ESTAD trains tomorrow's leaders through four pillars of excellence. Join the university of innovation at the heart of Central Africa.",
  hero_card_address: "Palais des Congrès, Lower Section",
  hero_card_city: "Yaoundé, Cameroon",
  hero_card_email: "secretariat@estad-university.com",
  hero_card_phone: "(+237) 682 29 12 12",

  // Programs Hero Card
  programs_hero_card_intro: "ESTAD offers four excellence pillars — Telecommunications, Computer Science, Digital Communication, and Energy — structured around the LMD academic pathway and a 7-step entrepreneurial coaching journey.",
  programs_hero_card_pillar1: "Telecoms & Computer Science",
  programs_hero_card_pillar2: "Digital Communication",
  programs_hero_card_pillar3: "Energy Engineering",
  programs_hero_card_pillar4: "Entrepreneurial Coaching",
  programs_hero_card_cta: "Explore Programs",

  // Research Hero Card
  research_hero_card_intro: "ESTAD hosts one of only 15 WIPO-registered CATI centers in Cameroon. Our RAFT approach turns every course into an innovation opportunity.",
  research_hero_card_cati: "WIPO CATI Center — 1 of 15 in Cameroon",
  research_hero_card_areas: "6 Active Research Areas",
  research_hero_card_partners: "Global Research Partners",
  research_hero_card_cta: "Discover Our Labs",

  // Partnerships Hero Card
  partnerships_hero_card_intro: "A global network spanning Cameroon, Europe, Canada, India, and Asia. ESTAD holds BeingCert USA exclusivity across 11 CEMAC countries.",
  partnerships_hero_card_count: "12+ Institutional Partners",
  partnerships_hero_card_beingcert: "BeingCert USA — CEMAC Exclusivity",
  partnerships_hero_card_global: "Europe · Canada · India · Asia",
  partnerships_hero_card_cta: "View All Partners",

  // Admissions Hero Card
  admissions_hero_card_intro: "Applications open January 2026. All motivated profiles are welcome — Baccalaureate or GCE A/L with 3 papers. No age limit.",
  admissions_hero_card_open: "Applications Open",
  admissions_hero_card_deadline: "Deadline",
  admissions_hero_card_start: "Academic Start",
  admissions_hero_card_requirement: "Baccalaureate or GCE A/L",
  admissions_hero_card_cta: "Apply Online",

  // Contact Hero Card
  contact_hero_card_intro: "We are here to help. Reach out for admissions, partnerships, or general inquiries. Our team responds within 24 hours.",
  contact_hero_card_address_label: "Address",
  contact_hero_card_address_value: "Palais des Congrès, Lower Section, Yaoundé",
  contact_hero_card_phone_label: "Phone",
  contact_hero_card_hours_label: "Office Hours",
  contact_hero_card_hours_value: "Mon — Fri: 8:00 AM — 5:00 PM",
  contact_hero_card_cta: "Get Directions",

  // Campus Hero Card
  campus_hero_card_intro: "A premium campus at the Palais des Congrès in Yaoundé. Bilingual environment, student associations, and an inclusive spiritual community.",
  campus_hero_card_location: "Palais des Congrès, Lower Section",
  campus_hero_card_bilingual: "French-English Bilingual Campus",
  campus_hero_card_associations: "BEDIR & ANIPES Student Bodies",
  campus_hero_card_cta: "Take a Virtual Tour",

  hero_title_line1: "The University",
  hero_title_line2: "of Tomorrow",
  hero_title_line3: "Let's Build the Future Together",
  hero_description_short: "ESTAD University Institute — Your partner for an education of excellence at the heart of Africa.",
  hero_tagline: "Inspire, Innovate, For a Better World!",
  hero_cta_apply: "Apply Now",
  hero_cta_discover: "Discover Our Programs",
  hero_cta_discover_piliers: "Discover our pillars",

  // Stats
  stats_founded_label: "Founded",
  stats_founded_value: "2020",
  stats_programs_label: "Programs",
  stats_programs_value: "6",
  stats_partners_label: "Partners",
  stats_partners_value: "10+",
  stats_cati_label: "CATI",
  stats_cati_value: "WIPO-Certified",

  // Why ESTAD
  why_title: "Why ESTAD?",
  why_subtitle: "A unique academic experience at the heart of Cameroonian innovation",
  why_card_tech_title: "Technology-Assisted Learning",
  why_card_tech_desc: "Digital platforms, hybrid courses, and modern labs for cutting-edge pedagogy.",
  why_card_entrepreneurship_title: "University Entrepreneurship",
  why_card_entrepreneurship_desc: "Business incubation, entrepreneurial coaching, and funding access for student projects.",
  why_card_diplomas_title: "National & International Diplomas",
  why_card_diplomas_desc: "Certifying programs recognized in Cameroon and internationally through our strategic partnerships.",
  why_card_innovation_title: "Innovation Center — CATI",
  why_card_innovation_desc: "One of only 15 WIPO centers in Cameroon. Intellectual property, applied research, and technology transfer.",

  // Program Search
  tab_search_programs: "Program Search",
  tab_formation_pro: "Professional Training",
  filter_all: "All programs",
  filter_bachelor: "Bachelor (Licence)",
  filter_master: "Master Professional",
  filter_doctorate: "Doctorate (Co-tutelle)",
  label_keyword: "Keyword",
  label_domain: "Area of Excellence",
  label_campus: "Campus / Level",
  btn_rechercher: "Search",
  link_advanced_search: "Advanced search options",

  // Pillars Section
  section_news_pillars: "News and our pillars",
  programs_7step_title_short: "7 Entrepreneurial Steps",
  common_learn_more_short: "Learn more",
  link_view_all_projects: "View more projects and stories",

  // Programs Page
  label_search_keyword: "Search by Keyword",
  placeholder_studying: "What are you interested in studying?",
  label_area_interest: "Area of Interest",
  domain_all_areas: "All Areas",
  label_credential_level: "Credential Level",
  level_all: "All Credentials",
  btn_search_programs: "Search Programs",
  showing_count: "Showing {{count}} {{label}}",
  sort_by: "Sort by:",
  sort_alphabetical: "Alphabetical",
  sort_credential: "Credential Level",
  common_details: "Details",
  cta_not_sure: "Not sure which program to choose?",
  cta_advisors_desc: "Our academic advisors are here to help you match your passions with the right academic path.",
  btn_request_info: "Request Information",
  btn_meet_advisor: "Meet an Advisor",

  // Philosophy Section
  pillar_foi: "Faith",
  pillar_rationalité: "Rationality",
  pillar_courage: "Courage",
  pillar_stratégie: "Strategy",

  // News & Events
  section_news_title: "In the News",
  section_events_title: "Events",
  news_inauguration_title: "Solemn Inauguration by the Minister of Higher Education",
  news_inauguration_desc: "ESTAD University Institute was officially inaugurated, marking a new era for academic innovation in Cameroon.",
  news_beingcert_title: "BeingCert USA Exclusivity for 11 CEMAC Countries",
  news_beingcert_desc: "An exclusive strategic partnership allowing our students to obtain international certifications in AI and Cybersecurity.",
  event_admissions_open: "2026 Admissions Opening",
  event_admissions_open_desc: "Beginning of file submissions for new graduates and professionals.",
  event_admissions_close: "Closing of Admission Files",
  event_admissions_close_desc: "Imperative deadline for Bachelor and Master programs.",
  event_academic_start: "2026-2027 Academic Start",
  event_academic_start_desc: "Solemn start ceremony at the Palais des Congrès.",

  // Info Section
  hero_card_intro_student: "Join our dynamic community and start your journey towards excellence today. Applications open for the 2026 session.",
  info_for_title: "Information for:",
  info_international_students: "International Students",
  info_partners_industry: "Partners & Industry",

  // Sidebar
  sidebar_resources_title: "Useful Resources",
  sidebar_resources_label: "Resources",
  sidebar_help_title: "Need help?",
  sidebar_help_desc: "Our admissions office is available to support you in your professional project.",
  sidebar_apply_title: "Ready to apply?",
  sidebar_apply_desc: "Join our next intake. Admissions open in January 2026.",
  link_vision_more: "Learn more about our vision",
  admissions_calendar_open_note: "Online applications",
  admissions_calendar_close_note: "File closing",
  admissions_calendar_start_note: "Academic inauguration",
  why_card_innovation_desc_short: "Official OMPI CATI Center registration for IP support.",
  research_raft_title_short: "RAFT Approach: Research As a Form of Teaching.",

  // Quick Links Section
  calendar_desc_short: "Important dates for admissions, college training, and holidays.",
  explore_campus_title: "Explore the Campus",
  explore_campus_desc_short: "Discover our modern facilities located in the heart of the political capital.",
  link_view_calendar: "View the calendar",
  link_virtual_tour: "Virtual tour",

  // News / Events
  news_title: "News & Events",
  news_subtitle: "Stay informed about ESTAD's academic and scientific life",
  news_read_more: "Read more",

  news_view_all: "View all events",

  // Newsletter
  newsletter_title: "Join the ESTAD Community",
  newsletter_subtitle: "Receive our news, admission calls, and events directly in your inbox.",
  newsletter_placeholder: "Your email address",
  newsletter_button: "Subscribe",
  newsletter_success: "Thank you for subscribing!",
  newsletter_error: "An error occurred. Please try again.",

  about_hero_badge: "Since 2020",
  about_hero_cta_leadership: "Our Leadership",
  about_hero_cta_vision: "Vision & Mission",
  about_hero_inauguration: "Inaugurated by the Minister of Higher Education",
  about_hero_inauguration_date: "Founded November 18, 2020, during the COVID-19 pandemic",
  about_hero_minesup_label: "MINESUP Authorization",
  about_hero_minesup_number: "No. 20-06511 — Founded November 18, 2020",

  about_leadership_badge: "Leadership",
  about_dg_founder_note: "Founder 2019 — Class of '94 Mines-Télécoms",

  about_name_badge: "Our Identity",
  about_name_full: "Higher School of Advanced Techniques for Development — a name that embodies our ambition: to train high-level professionals in cutting-edge technologies for sustainable development.",

  about_supervisors_badge: "Supervision",
  about_supervisor_polytech_desc: "Polytechnic School of Douala",
  about_supervisor_ube_desc: "Public University of Cameroon",

  // About Page
  about_title: "About ESTAD",
  about_history_title: "Our History",
  about_history_text1: "The École Supérieure des Techniques Avancées pour le Développement (ESTAD) was founded on November 18, 2020, in the midst of the COVID-19 pandemic, at a time when digital education and economic resilience became essential.",
  about_history_text2: "Authorized by MINESUP under number 20-06511, ESTAD represents a new generation of higher education institutions in Cameroon, focused on innovation, entrepreneurship, and technology.",
  about_name_title: "Our Name",
  about_name_e: "École (School)",
  about_name_s: "Supérieure (Higher)",
  about_name_t: "Techniques (Techniques)",
  about_name_a: "Avancées (Advanced)",
  about_name_d: "Développement (Development)",
  about_vision_title: "Our Vision",
  about_vision_text: "To become a globally recognized university of excellence, pioneering in entrepreneurship, innovation, and societal impact.",
  about_mission_title: "Our Mission",
  about_mission_text: "To teach, to learn, at all times, in all places, and at any age, to build a better world.",
  about_leadership_title: "Message from the Leadership",
  about_pca_title: "Board Chairman / President",
  about_pca_name: "Prof. Etienne Mfoumou, PhD",
  about_pca_message: "ESTAD was born from a bold vision: to create an academic ecosystem where research, innovation, and entrepreneurship converge to transform Cameroon and Africa.",
  about_dg_title: "General Director",
  about_dg_name: "MEZOM MELOUTA",
  about_dg_role: "ICT Engineer, Mines-Télécoms-Nord Europe Class of '94, founder 2019",
  about_dg_message: "Our ambition is to train student-entrepreneurs capable of creating technological and economic value, supported by an international network of academic and industrial partners.",
  about_supervisors_title: "Academic Supervisors",
  about_supervisor_polytech: "Polytech Douala",
  about_supervisor_ube: "University of Bertoua (UBe)",
  about_lmd_title: "LMD System",
  about_lmd_desc: "Bachelor-Master-Doctorate: L1/L2 common core, DUT, Bachelor, Master 1 & 2, Doctorate (international co-tutorship).",
  about_tice_highlight: "First private school in Cameroon using ICT as its core teaching methodology",
  about_philosophy_title: "Our Philosophy",
  about_philosophy_quote: "Born in God's Image, you are CO-CREATOR",
  about_philosophy_pillars: "Faith + Rationality + Courage + Strategy",
  about_loi_title: "University-Enterprise",
  about_loi_desc: "Law 2023/007: Cameroonian legal framework for university-enterprise collaboration driving innovation and employability.",
  about_beingcert_title: "BeingCert USA — CEMAC Exclusivity",
  about_beingcert_desc: "ESTAD holds the BeingCert USA exclusivity for 11 CEMAC countries in Artificial Intelligence and Cybersecurity.",

  about_lmd_badge: "Academic Pathway",

  about_lmd_step_1_desc: "Common Core",
  about_lmd_step_2_desc: "University Diploma",
  about_lmd_step_3_desc: "Bachelor",
  about_lmd_step_4_desc: "Professional Master",
  about_lmd_step_5_desc: "International Co-Tutorship",

  // Programs Page
  programs_title: "Our Programs",
  programs_subtitle: "Four pillars of excellence to train tomorrow's leaders",
  programs_pillar_t: "Telecommunications (T)",
  programs_pillar_t_desc: "Telecommunications engineering, mobile networks, fiber optics, 5G, and embedded systems.",
  programs_pillar_i: "Computer Science (I)",
  programs_pillar_i_desc: "Computer science, software development, artificial intelligence, cybersecurity, and data science.",
  programs_pillar_c: "Digital Media & Communication (C)",
  programs_pillar_c_desc: "Digital media, interactive design, audiovisual production, digital marketing, and data journalism.",
  programs_pillar_e: "Energy Engineering (E)",
  programs_pillar_e_desc: "Energy engineering, renewable energies, smart grids, and energy transition.",
  programs_pathway_title: "Academic Pathway",
  programs_pathway_initial: "Initial Training",
  programs_pathway_initial_steps: "Common Core (4 sem) → DUT/BTS/DU → Bachelor (2 sem) → Master 1&2 (4 sem) → Doctorate (8 sem, co-tutored)",
  programs_pathway_continuing: "Continuing Education",
  programs_pathway_continuing_desc: "Personalized pathway, Recognition of Prior Learning (VAE), professional certifications from 1 to 3 months.",
  programs_journey_title: "Student Journey",
  programs_journey_from: "Student-Entrepreneur",
  programs_journey_to: "Entrepreneur-Industrialist",
  programs_7step_title: "Entrepreneurial Journey — 7 Steps",
  programs_7step_subtitle: "From Student-Entrepreneur to Entrepreneur-Industrialist",
  programs_7step_1: "Faith",
  programs_7step_2: "Idea",
  programs_7step_3: "Pathway",
  programs_7step_4: "Tools",
  programs_7step_5: "Model",
  programs_7step_6: "Finance",
  programs_7step_7: "Monetize",
  programs_ube_title: "Schools/UBe Departments",
  programs_ube_1: "Wood Sciences & Forestry",
  programs_ube_2: "Mines & Industry (Mechatronics)",
  programs_certifications_title: "Short Certifications",
  programs_certifications_desc: "Continuing education from 1 to 3 months: VAE, work-study, professional certifications. State-recognized diplomas, national and international co-diplomation.",

  partnerships_hero_badge: "Global Network",
  partners_badge: "Collaboration",
  partnerships_map_badge: "Reach",
  partnerships_future_badge: "Horizons",

  // Admissions Page
  info_future_students: "Future Students",
  info_future_students_desc: "Discover our Bachelor and Master programs adapted to market needs.",
  info_intl_desc: "Information for international students wishing to join ESTAD in Cameroon.",
  scholarships_hero_subtitle_short: "Check our excellence and merit scholarship programs for 2026.",
  admissions_steps_title: "Steps to Apply",
  step_research_title: "Program Research",
  step_research_desc: "Explore our 4 pillars of excellence: Telecoms, IT, Digital Communication and Energy Engineering. Choose the LMD path that suits you.",
  step_verify_title: "Verify Conditions",
  step_verify_desc: "Ensure you have your Baccalaureate or GCE A/L with at least 3 subjects (excluding Religious Knowledge). No age limit is imposed to favor continuing education.",
  step_submit_title: "Submit Dossier",
  step_submit_desc: "Fill out the online pre-registration form and attach your transcripts, ID, and motivation letter.",
  step_confirm_title: "Confirmation & Enrollment",
  step_confirm_desc: "After reviewing your file (2-3 weeks), you will receive a decision notification. Payment of registration fees finalizes your admission.",

  admissions_title: "Admissions",
  admissions_subtitle: "Join ESTAD and build your future",
  admissions_requirements_title: "Admission Requirements",
  admissions_requirements_bacc: "Baccalaureate or recognized equivalent",
  admissions_requirements_gce: "GCE A/L with 3 papers (except Religious Knowledge)",
  admissions_requirements_age: "Age: no limit (lifelong learning)",
  admissions_requirements_docs: "Complete file: transcripts, ID, photos, motivation letter",
  admissions_requirements_fees: "Registration fees paid",
  admissions_calendar_title: "Admission Calendar",
  admissions_fees_title: "Tuition Fees",
  admissions_fees_note: "Tuition fees vary by program. Contact us for a personalized quote.",
  admissions_entry_title: "Primary Entry Path",
  admissions_entry_desc: "Baccalaureate or GCE Advanced Level with 3 papers (except Religious Knowledge). All motivated profiles are welcome.",
  admissions_cta: "Submit your application online",
  admissions_brochure: "Download Student Handbook",
  admissions_form_title: "Pre-Registration Form",
  admissions_form_name: "Full name",
  admissions_form_email: "Email address",
  admissions_form_program: "Desired program",
  admissions_form_message: "Message (max 500 characters)",
  admissions_form_submit: "Send my application",
  admissions_faq_title: "Frequently Asked Questions",
  admissions_faq_q1: "What degrees does ESTAD award?",
  admissions_faq_a1: "ESTAD awards national degrees (DUT, Bachelor, Master, Doctorate) and international certifications through our partners.",
  admissions_faq_q2: "Can I apply online?",
  admissions_faq_a2: "Yes, our online application platform is accessible 24/7. You can submit your file and track its progress.",
  admissions_faq_q3: "Does ESTAD accept VAE?",
  admissions_faq_a3: "Yes, we offer Validation of Acquired Experience (VAE) for our continuing education programs.",
  admissions_faq_q4: "What are the processing times?",
  admissions_faq_a4: "Files are processed within 2 to 3 weeks. A final response is sent by email.",
  admissions_faq_q5: "Are scholarships available?",
  admissions_faq_a5: "Yes, excellence scholarships and merit-based aid are available. Contact our admissions office.",
  admissions_faq_q6: "Can I study part-time?",
  admissions_faq_a6: "Yes, our continuing education offer allows personalized-paced learning, including evenings and weekends.",

  programs_hero_badge: "Excellence Training",

  programs_7step_badge: "Entrepreneurial Coaching",
  programs_pathway_badge: "Academic Pathway",
  programs_ube_badge: "University of Bertoua",
  programs_pillar_note: "Pillar programs are offered under the University of Douala (UDo), in partnership with Polytechnique Douala.",
  programs_journey_from_desc: "Training, innovation, academic projects",
  programs_journey_to_desc: "Business, impact, international reach",

  programs_pathway_step_1: "Common Core",
  programs_pathway_step_2: "DUT / BTS",
  programs_pathway_step_3: "Bachelor",
  programs_pathway_step_4: "Master 1 & 2",
  programs_pathway_step_5: "Doctorate",
  programs_pathway_duration_1: "4 sem",
  programs_pathway_duration_2: "2 years",
  programs_pathway_duration_3: "2 sem",
  programs_pathway_duration_4: "4 sem",
  programs_pathway_duration_5: "8 sem",

  // Research Page
  research_title: "Research & Innovation",
  research_subtitle: "Turning research into concrete impact",
  research_cati_title: "CATI — Technological Innovation Support Center",
  research_cati_desc1: "ESTAD hosts one of only 15 CATI centers in all of Cameroon, registered with WIPO (World Intellectual Property Organization).",
  research_cati_desc2: "CATI offers comprehensive intellectual property support, WIPO-certified training, and an incubator for innovative projects.",
  research_cati_desc3: "Cameroon has over 480 higher education institutions; ESTAD stands out among the 15 national CATI centers.",
  research_cati_features_ip: "Intellectual Property Support",
  research_cati_features_training: "WIPO-Certified Training",
  research_cati_features_incubation: "Innovation Incubation",
  research_raft_title: "RAFT — Research As a Form of Teaching",
  research_raft_desc: "Our integrated research-teaching concept places the student at the heart of scientific discovery, turning every course into an innovation opportunity.",
  research_partners_title: "Research Partners",
  research_partners_crdi: "IDRC Canada",
  research_partners_crdi_date: "",
  research_partners_minmidt: "MINMIDT Cameroon",
  research_partners_minmidt_date: "November 2022",
  research_partners_cbhi: "CBHI",
  research_partners_cbhi_date: "",
  research_partners_esbafim: "ESBAFIM",
  research_partners_esbafim_date: "",
  research_partners_riis: "RIIS",
  research_partners_riis_date: "",
  research_partners_qh: "QH India",
  research_partners_qh_date: "December 2024",
  research_timeline_title: "Milestones Timeline",
  research_timeline_2019: "ESTAD project founded by MEZOM MELOUTA, ICT Engineer Class of '94",
  research_timeline_2020: "Foundation of ESTAD and MINESUP authorization",
  research_timeline_2021: "Launch of first LMD programs",
  research_timeline_2022: "CATI registration under WIPO program",
  research_timeline_2023: "Partnership with Polytech Douala and UBe",
  research_timeline_2024: "First Master graduating class",
  research_timeline_2025: "International expansion — Asia & Europe partnerships",
  research_timeline_2026: "Doctorate co-tutorship and internationalization",
  research_dlab_title: "ATF D-LABs — Transdisciplinary Approach",
  research_dlab_subtitle: "Integrate · Innovate · Collaborate",
  research_dlab_pipeline_1: "Concept",
  research_dlab_pipeline_2: "Proof",
  research_dlab_pipeline_3: "Technico-economic",
  research_dlab_pipeline_4: "Launch",
  research_areas_title: "Research Areas",
  research_area_1: "Mechanotransduction",
  research_area_2: "Elastography (thrombosis)",
  research_area_3: "FTIR Spectroscopy",
  research_area_4: "Palm kernel / cocoa shell valorization",
  research_area_5: "Additive manufacturing",
  research_area_6: "AI & data mining",

  research_hero_badge: "Innovation & Impact",
  research_cati_badge: "CATI Center",
  research_dlab_badge: "Transdisciplinary Approach",
  research_areas_badge: "Expertise",
  research_timeline_badge: "Timeline",
  research_partners_badge: "Collaborations",

  // Partnerships Page
  partnerships_title: "Partnerships & International Relations",
  partnerships_subtitle: "A global network at the service of academic excellence",
  partners_title: "Our Institutional Partners",
  partner_polytech: "Polytech Douala",
  partner_ube: "University of Bertoua",
  partner_ompi: "WIPO",
  partner_crdi: "IDRC Canada",
  partner_minmidt: "MINMIDT",
  partner_capef: "CAPEF",
  partner_pacy: "PACY",
  partner_mepmi: "ME/PMI",
  partner_isabe: "ISABE",
  partner_velsoft: "Velsoft Canada",
  partner_beingcert: "BeingCert USA",
  partner_anipes: "ANIPES",
  partnerships_anipes_title: "ESTAD = ANIPES-CENTRE",
  partnerships_anipes_desc: "Yaoundé 2 Representation — Bureau of Diversity, Intersectionality and Public Relations",
  partnerships_map_title: "International Reach",
  partnerships_quote: "Partnerships are not signatures on paper — they are bridges we build between Cameroonian talent and global excellence.",
  partnerships_quote_author: "MEZOM MELOUTA, DG ESTAD",
  partnerships_future_title: "Future Horizons",
  partnerships_future_1: "Major Projects Consortium",
  partnerships_future_2: "PoPs Model (Proof of Projects)",
  partnerships_future_3: "ATF D-Factory",
  partnerships_dg_quote_text: "ESTAD Towards You and You Towards ESTAD",
  partnerships_dg_quote_author: "MEZOM MELOUTA, DG ESTAD",

  admissions_hero_badge: "Join ESTAD",
  admissions_req_badge: "Application",
  admissions_calendar_open: "Application Opening",
  admissions_calendar_open_date: "January 2026",
  admissions_calendar_close: "Application Deadline",
  admissions_calendar_close_date: "June 30, 2026",
  admissions_calendar_interview: "Selection Interviews",
  admissions_calendar_interview_date: "July — August 2026",
  admissions_calendar_start: "Academic Start",
  admissions_calendar_start_date: "October 2026",
  admissions_form_subtitle: "Fill out the form below to start your application",
  admissions_faq_badge: "FAQ",

  // Campus Page
  campus_title: "Campus Life",
  campus_subtitle: "An inspiring learning environment in the heart of Yaoundé",
  campus_gallery_title: "Photo Gallery",
  campus_associations_title: "Student Associations",
  campus_association_bedir: "BEDIR — Student Bureau",
  campus_association_anipes: "ANIPES — Student Association",
  campus_bilingual_title: "Bilingualism Policy",
  campus_bilingual_desc: "ESTAD promotes French-English bilingual excellence. All our courses, exams, and administrative documents are available in both languages.",
  campus_bilingual_detail1: "Bilingual assignments and coursework",
  campus_bilingual_detail2: "National language summaries at thesis defenses",
  campus_location_title: "Our Address",
  campus_location_address: "Palais des Congrès, Lower Section, Yaoundé, Cameroon",
  campus_location_desc: "A premium, central, and accessible location in the political capital of Cameroon.",
  campus_spiritual_title: "Social & Spiritual Dimension",
  campus_spiritual_desc: "Sister Victorine, Emmanuel and Rachel welcome you. Our campus cultivates a caring, inclusive environment rooted in humanist values.",
  campus_welcome_title: "Welcome to Campus",
  campus_welcome_text: "Sister Reverend Victorine, Emmanuel and Rachel welcome you.",
  campus_visit_quote: "Palais des Congrès, Lower Section — absolutely worth a visit",
  campus_values_title: "Our Values",
  campus_values_quote: "Do no harm, do everything to build peace",

  campus_gallery_subtitle: "A glimpse of life on the ESTAD campus",

  campus_hero_badge: "Student Life",
  campus_gallery_badge: "Gallery",

  // Contact Page
  contact_title: "Contact Us",
  contact_subtitle: "We are listening. Do not hesitate to reach out.",
  contact_form_name: "Full name",
  contact_form_email: "Email address",
  contact_form_subject: "Subject",
  contact_form_program: "Program of interest",
  contact_form_message: "Your message (max 500 characters)",
  contact_form_submit: "Send",
  contact_form_success: "Your message has been sent successfully!",
  contact_form_error: "An error occurred. Please try again.",
  contact_info_address: "Address",
  contact_info_address_value: "Palais des Congrès, Lower Section, Yaoundé, Cameroon",
  contact_info_phone: "Phone",
  contact_info_email: "Email",
  contact_info_website: "Website",
  contact_info_website_value: "www.ESTAD-University.com",
  contact_info_phone_value: "(+237) 682 29 12 12 / 696 98 48 48 / 690 02 80 61",
  contact_whatsapp_number: "+237682291212",
  contact_hours_title: "Office Hours",
  contact_hours_value: "Monday — Friday: 8:00 AM — 5:00 PM",
  contact_social_title: "Follow Us",
  contact_whatsapp: "Contact us on WhatsApp",
  contact_map_title: "Location",

  contact_hero_badge: "Contact",
  contact_form_heading: "Send us a message",

  // Footer
  footer_tagline: "Inspire, Innovate, For a Better World!",
  footer_quick_links: "Quick Links",
  footer_link_home: "Home",
  footer_link_about: "About",
  footer_link_programs: "Programs",
  footer_link_admissions: "Admissions",
  footer_link_research: "Research",
  footer_link_contact: "Contact",
  footer_programs: "Our Programs",
  footer_prog_telecoms: "Telecommunications",
  footer_prog_info: "Computer Science",
  footer_prog_comm: "Digital Media & Communication",
  footer_prog_energy: "Energy Engineering",
  footer_contact: "Contact",
  footer_contact_address: "Palais des Congrès, Lower Section",
  footer_contact_city: "Yaoundé, Cameroon",
  footer_contact_phone: "(+237) 682 29 12 12 / 696 98 48 48 / 690 02 80 61",
  footer_contact_email: "secretariat@estad-university.com",
  footer_bottom_copyright: "© ESTAD-University 2026",
  footer_bottom_oapi: "OAPI Registered Logo",
  footer_motto: "Faith — Rationality — Innovation",
  footer_latin_motto: "Crede et quod vis fac — St. Augustine",

  // Common
  common_read_more: "Read more",
  common_learn_more: "Learn more",
  common_download: "Download",
  common_send: "Send",
  common_close: "Close",
  common_loading: "Loading...",
  common_required: "Required field",
  common_invalid_email: "Invalid email address",
  common_max_chars: "Maximum {count} characters",
  common_all_programs: "All programs",
  common_program_telecoms: "Telecommunications",
  common_program_info: "Computer Science",
  common_program_comm: "Digital Media & Communication",
  common_program_energy: "Energy Engineering",
  common_select: "Select...",
  common_year: "Year",
  common_semester: "Semester",

  presentation_filiere: "Program Presentation",
  tutelle_academique: "Academic Supervision",
  objectifs_pedagogiques: "Educational Objectives",
  programme_modules: "Program & Modules",
  parcours_academique_lmd: "LMD Academic Pathway",
  debouches_professionnels: "Career Opportunities",
  certifications_associees: "Associated Certifications",
  durée: "Duration",
  crédits: "Credits",
  niveau: "Level",
  superviseur: "Supervisor",
  candidatez_filiere: "Apply to the Program:",
  common_apply_now: "Apply Now",
  common_meet_advisor: "Speak with an Advisor",
  filiere_precedente: "Previous Program",
  filiere_suivante: "Next Program",
  no_programs_found: "No programs found.",
  reset_filters: "Reset Filters",

  // News Page
  news_page_title: "News & Events",
  news_page_subtitle: "Stay informed about the latest news, events and opportunities at ESTAD",
  news_back_to_list: "Back to news",
  news_related: "Related articles",
  news_share: "Share this article",
  news_subscribe_title: "Don't miss any news",
  news_subscribe_desc: "Subscribe to our newsletter to receive the latest information on events, training and opportunities",
  news_subscribe_cta: "Subscribe to newsletter",

  // Partner Types
  partner_polytech_type: "Academic Partner",
  partner_ube_type: "Partner University",
  partner_ompi_type: "International Organization",
  partner_crdi_type: "Research Center",
  partner_minmidt_type: "Ministry",
  partner_capef_type: "Financial Institution",
  partner_pacy_type: "Association",
  partner_mepmi_type: "Public Institution",
  partner_isabe_type: "Partner School",
  partner_velsoft_type: "Technology Partner",
  partner_beingcert_type: "Certification",
  partner_anipes_type: "Innovation Center",

  // Research Page - CATI Features
  research_cati_feature_ip: "Intellectual Property Protection",
  research_cati_feature_training: "Training & Certification",
  research_cati_feature_incubation: "Startup Incubation",
  research_cati_feature_patents: "Patent Filing",
  research_cati_feature_techtransfer: "Technology Transfer",

  // Research Page - Timeline Details
  research_milestone_2019_title: "CATI Foundation",
  research_milestone_2019_desc: "Registration of the African Technology and Innovation Center with OAPI",
  research_milestone_2020_title: "RAFT Launch",
  research_milestone_2020_desc: "Introduction of the Research Accelerated Fast Track methodology",
  research_milestone_2021_title: "First Patents",
  research_milestone_2021_desc: "Filing of first patent applications by ESTAD students",
  research_milestone_2022_title: "QH India Partnership",
  research_milestone_2022_desc: "International collaboration in quantum research",
  research_milestone_2023_title: "D-Labs",
  research_milestone_2023_desc: "Opening of decentralized research laboratories",
  research_milestone_2024_title: "OAPI Excellence",
  research_milestone_2024_desc: "Recognition as a center of excellence in intellectual property",
  research_milestone_2025_title: "Expansion",
  research_milestone_2025_desc: "Opening of 3 new specialized laboratories",
  research_milestone_2026_title: "Vision 2030",
  research_milestone_2026_desc: "Launch of the ten-year research program",

  // Research Areas 7 & 8
  research_area_7: "Renewable Energy",
  research_area_8: "IoT & Networks",

  // Research CATI Features - Plural form
  research_cati_features_patents: "Patent Filing",
  research_cati_features_techtransfer: "Technology Transfer",

  // Partnerships - Additional translations
  partnerships_benefits_badge: "Benefits",
  partnerships_benefits_title: "Why Partner with ESTAD?",
  partnerships_benefits_desc: "Our partnerships create value through academic excellence, professional integration, and international opportunities.",
  partnerships_collab_badge: "Collaboration",
  partnerships_collab_title: "Types of Partnership",
  partnerships_collab_desc: "ESTAD engages with partners across multiple domains to create comprehensive value for students and institutions.",
  partnerships_network_badge: "Network",
  partnerships_network_title: "Our Partner Institutions",
  partnerships_network_desc: "Discover the organizations that make ESTAD's excellence possible through strategic collaboration.",
  partnerships_key_benefits: "Key Benefits",
  partnerships_location: "Cameroon — Yaoundé",
  partnerships_global_reach: "Europe — Canada — India — Asia",
  partnerships_gallery_badge: "Gallery",
  partnerships_gallery_title: "Partnerships in Action",
  partnerships_gallery_desc: "Visual highlights of our collaborative initiatives and events",

  // Partnership Benefits
  partnerships_benefit_academic_title: "Academic Excellence",
  partnerships_benefit_academic_desc: "Access to internationally recognized programs with dual diploma opportunities and academic co-supervision.",
  partnerships_benefit_professional_title: "Professional Integration",
  partnerships_benefit_professional_desc: "Direct pathways to employment through corporate partnerships, internships, and entrepreneurial support.",
  partnerships_benefit_mobility_title: "International Mobility",
  partnerships_benefit_mobility_desc: "Exchange programs, study abroad opportunities, and global research collaborations across 4 continents.",
  partnerships_benefit_research_title: "Innovation & Research",
  partnerships_benefit_research_desc: "Access to CATI-WIPO center, patent filing support, and cutting-edge research facilities.",
  partnerships_benefit_certified_title: "Certified Training",
  partnerships_benefit_certified_desc: "International certifications including BeingCert exclusivity for AI and Cybersecurity across CEMAC.",
  partnerships_benefit_network_title: "Network & Community",
  partnerships_benefit_network_desc: "Join a global network of students, researchers, and professionals across Cameroon and internationally.",

  // Collaboration Types
  partnerships_collab_academic_title: "Academic Partnerships",
  partnerships_collab_academic_desc: "Dual degrees, co-supervised theses, student exchanges, and joint research programs with leading universities.",
  partnerships_collab_research_title: "Research & Innovation",
  partnerships_collab_research_desc: "Collaboration on applied research projects, technology transfer, and intellectual property protection.",
  partnerships_collab_professional_title: "Professional Integration",
  partnerships_collab_professional_desc: "Internships, apprenticeships, and direct employment pathways with corporate partners.",
  partnerships_collab_tech_title: "Technology & Certification",
  partnerships_collab_tech_desc: "Access to cutting-edge educational technology and international certification programs.",

  // Partner Descriptions
  partner_polytech_desc: "Polytechnic School of Douala — Cameroon's premier technical higher education institution, offering excellent academic supervision for engineering programs.",
  partner_ube_desc: "Public university of Cameroon specialized in forest, mining and industrial sciences. Preferred partner for Master's and PhD programs.",
  partner_ompi_desc: "African Intellectual Property Organization and World Intellectual Property Organization. Strategic partner for intellectual property protection.",
  partner_crdi_desc: "International Development Research Centre — Canadian organization funding scientific research in developing countries.",
  partner_minmidt_desc: "Ministry of Mines, Industry and Technological Development of Cameroon. Government partner for industrial innovation.",
  partner_capef_desc: "Deposit and Consignment Fund — Cameroonian financial institution supporting economic development and entrepreneurship.",
  partner_pacy_desc: "Cameroonian academic and institutional partner committed to youth development and education.",
  partner_mepmi_desc: "Ministry of Small and Medium Enterprises — Partner for entrepreneurial support and professional integration of students.",
  partner_isabe_desc: "Higher Institute of Business and European Affairs — European partner for international programs and academic mobility.",
  partner_velsoft_desc: "Canadian publisher of pedagogical solutions and training content — Partner for digital educational resources.",
  partner_beingcert_desc: "International American certification body. ESTAD holds BeingCert exclusivity for 11 CEMAC countries in Artificial Intelligence and Cybersecurity.",
  partner_anipes_desc: "Association for Diversity, Intersectionality and Public Relations — Yaoundé 2 Representation Office, center for innovation and inclusion.",

  // Partner Benefits
  partner_benefit_academic: "Academic Supervision",
  partner_benefit_diploma: "Diploma Recognition",
  partner_benefit_resources: "Access to Scientific Resources",
  partner_benefit_cotutelle: "Co-supervision of Theses",
  partner_benefit_joint: "Joint Programs",
  partner_benefit_mobility: "Student Mobility",
  partner_benefit_patents: "Patent Registration",
  partner_benefit_training: "WIPO Training",
  partner_benefit_ip: "IP Protection",
  partner_benefit_funding: "Research Funding",
  partner_benefit_intl: "International Partnerships",
  partner_benefit_publication: "Scientific Publication",
  partner_benefit_institutional: "Institutional Support",
  partner_benefit_industrial: "Industrial Projects",
  partner_benefit_tech: "Technological Innovation",
  partner_benefit_financing: "Project Financing",
  partner_benefit_coaching: "Entrepreneurial Coaching",
  partner_benefit_credit: "Credit Access",
  partner_benefit_network: "Professional Network",
  partner_benefit_internship: "Internship Opportunities",
  partner_benefit_personal: "Personal Development",
  partner_benefit_startup: "Company Creation",
  partner_benefit_sme: "SME Support",
  partner_benefit_entrepreneur: "Entrepreneur Network",
  partner_benefit_dual: "Dual Degree",
  partner_benefit_europe: "Europe Mobility",
  partner_benefit_global: "International Network",
  partner_benefit_pedagogical: "Pedagogical Content",
  partner_benefit_elearning: "E-learning Training",
  partner_benefit_educational: "Educational Resources",
  partner_benefit_certifications: "International Certifications",
  partner_benefit_cemac: "CEMAC Exclusivity",
  partner_benefit_ai: "AI & Cybersecurity",
  partner_benefit_inclusion: "Inclusion",
  partner_benefit_diversity: "Diversity",
  partner_benefit_pr: "Public Relations",

  // Partner Categories
  partners_categories_badge: "Our Partners",
  partners_categories_title: "A Network of Excellence",
  partners_categories_desc: "ESTAD collaborates with prestigious institutions to provide exceptional education and unique opportunities for its students.",

  partners_category_institutional_title: "Institutional Partners",
  partners_category_institutional_subtitle: "Institutional",
  partners_category_academic_title: "Academic Supervision",
  partners_category_academic_subtitle: "Academic",
  partners_category_private_title: "Private Partners",
  partners_category_private_subtitle: "Private",
  partners_category_anipes_title: "ANIPES Partners",
  partners_category_anipes_subtitle: "ANIPES",

  // Additional Partner Short Descriptions
  partner_minmidt_short_desc: "Ministry of Mines, Industry and Technological Development",
  partner_palais_congres_desc: "Yaoundé Congress Palace — ESTAD Host",
  partner_mepmi_short_desc: "Ministry of Small and Medium Enterprises",
  partner_capef_short_desc: "Deposit and Consignment Fund — Financial Support",

  // Academic Partners Descriptions
  partner_ud_desc: "University of Douala — Major Academic Partner",
  partner_estmre_desc: "Higher School of Mines and Energy Resources",
  partner_isabee_desc: "Higher Institute of Agriculture, Wood, Water and Environment",

  // Research Partners
  partner_riis_desc: "Research Institute for Innovation and Science",
  partner_qh_desc: "QH India — Quantum Research Partner",

  // Supervisor Institutions
  about_supervisors_subtitle: "ESTAD benefits from academic and scientific supervision of five institutions of excellence",
  supervisor_ud: "University of Douala",
  supervisor_ud_desc: "Leading public university in Cameroon",
  supervisor_ube: "University of Bertoua",
  supervisor_ube_desc: "Public University — Forestry and Industrial Sciences",
  supervisor_enspd: "National Higher Polytechnic School of Douala",
  supervisor_enspd_desc: "Premier technical higher education institution",
  supervisor_estmre: "Higher School of Mines and Energy Resources",
  supervisor_estmre_desc: "Excellence in mining and energy engineering",
  supervisor_isabee: "Higher Institute of Agriculture, Wood, Water and Environment",
  supervisor_isabee_desc: "Training in agricultural and environmental sciences",

  // Why ESTAD Page
  why_hero_badge: "Why Choose Us",
  why_hero_title: "Excellence at the Heart of Innovation",
  why_hero_subtitle: "ESTAD combines academic excellence, technological innovation, and entrepreneurship to train tomorrow's leaders.",
  why_reasons_badge: "Our Strengths",
  why_reasons_title: "What Sets Us Apart",
  why_card_excellence_title: "Academic Excellence",
  why_card_excellence_desc: "Certified and internationally recognized programs with an exceptional faculty.",
  why_stat_programs: "Available programs",
  why_card_international_title: "International Reach",
  why_card_international_desc: "Partnerships with prestigious institutions worldwide for maximum openness.",
  why_stat_partners: "International partners",
  why_stat_steps: "Steps in the journey",
  why_stat_cati: "CATI center in Cameroon",
  why_diff_badge: "Our Difference",
  why_diff_title: "A Unique Approach",
  why_diff_subtitle: "ESTAD innovates through its pedagogy, partnerships, and exceptional learning environment.",
  why_diff_digital_title: "Digital Pedagogy",
  why_diff_digital_desc: "Advanced technologies and e-learning platforms for modern learning.",
  why_diff_dual_title: "Dual Degree",
  why_diff_dual_desc: "Opportunity to obtain national and international certifications.",
  why_diff_location_title: "Prestigious Location",
  why_diff_location_desc: "Campus at the Yaoundé Congress Palace, accessible and secure.",
  why_diff_cert_title: "Recognized Certifications",
  why_diff_cert_desc: "Diplomas and certifications valued by employers worldwide.",
  why_cta_title: "Ready to Join Excellence?",
  why_cta_subtitle: "Discover our programs and start your journey towards academic and professional excellence.",
  why_cta_programs: "Explore Programs",
  why_cta_apply: "Apply Now",

  // Bachelor Page
  bachelor_title: "Bachelor",
  bachelor_hero_title: "Bachelor Programs",
  bachelor_hero_subtitle: "Complete 3-year programs (180 credits) preparing students for tomorrow's careers in technology and innovation.",
  bachelor_programs_badge: "Our Bachelor's",
  bachelor_programs_title: "Choose Your Field",
  bachelor_telecoms_title: "Telecommunications",
  bachelor_telecoms_desc: "Complete training in telecommunications engineering, mobile networks, fiber optics, and embedded systems.",
  bachelor_informatique_title: "Computer Science",
  bachelor_informatique_desc: "Software development, artificial intelligence, cybersecurity, and data science.",
  bachelor_communication_title: "Digital Communication",
  bachelor_communication_desc: "Digital media, interactive design, audiovisual production, and digital marketing.",
  bachelor_energy_title: "Renewable Energy",
  bachelor_energy_desc: "Energy engineering, renewable energies, smart grids, and energy transition.",
  bachelor_highlights_badge: "Highlights",
  bachelor_highlights_title: "Why Choose Our Bachelor Programs",
  bachelor_cta_title: "Ready to Start Your Journey?",
  bachelor_cta_apply: "Apply Now",
  bachelor_cta_contact: "Meet an Advisor",

  // Master Page
  master_title: "Master",
  master_hero_title: "Master Programs",
  master_hero_subtitle: "Advanced 2-year programs (120 credits) for professionals seeking to deepen their expertise and develop research skills.",
  master_programs_badge: "Our Masters",
  master_programs_title: "Specialize",
  master_telecoms_title: "Master in Telecommunications",
  master_telecoms_desc: "Advanced expertise in 5G/6G networks, IoT, cloud computing, and telecom architecture.",
  master_informatique_title: "Master in Computer Science",
  master_informatique_desc: "Advanced development, software architecture, DevOps, and IT project management.",
  master_data_science_title: "Master in Data Science",
  master_data_science_desc: "Machine learning, deep learning, big data analytics, and artificial intelligence.",
  master_cybersecurity_title: "Master in Cybersecurity",
  master_cybersecurity_desc: "Offensive and defensive security, forensic, governance, and compliance.",
  master_highlights_badge: "Highlights",
  master_highlights_title: "Why Choose Our Master Programs",
  master_cta_title: "Ready to Level Up?",
  master_cta_apply: "Apply to Master",
  master_cta_contact: "Meet an Advisor",

  // Scholarships Page
  scholarships_hero_badge: "Study Funding",
  scholarships_hero_title: "Scholarships & Financial Aid",
  scholarships_hero_subtitle: "ESTAD is committed to making educational excellence accessible. Discover our scholarship and financial aid programs.",
  scholarship_stat_budget: "Annual budget",
  scholarship_stat_recipients: "Scholarship recipients",
  scholarship_stat_types: "Types of scholarships",
  scholarship_stat_coverage: "Max coverage rate",
  scholarship_types_badge: "Types of Scholarships",
  scholarship_types_title: "Find the Scholarship for You",
  scholarship_excellence_title: "Excellence Scholarship",
  scholarship_excellence_desc: "For students with exceptional academic results. Covers up to 100% of tuition fees.",
  scholarship_excellence_criteria_1: "General average ≥ 16/20",
  scholarship_excellence_criteria_2: "Excellent academic record",
  scholarship_excellence_criteria_3: "Letters of recommendation",
  scholarship_merit_title: "Merit Scholarship",
  scholarship_merit_desc: "Recognizes talented students and their engagement in university life.",
  scholarship_merit_criteria_1: "General average ≥ 14/20",
  scholarship_merit_criteria_2: "Participation in ESTAD activities",
  scholarship_merit_criteria_3: "Viable entrepreneurial project",
  scholarship_need_title: "Social Scholarship",
  scholarship_need_desc: "Supports students with demonstrated financial needs.",
  scholarship_need_criteria_1: "Income documentation",
  scholarship_need_criteria_2: "Detailed motivation letter",
  scholarship_need_criteria_3: "Interview with the committee",
  scholarship_intl_title: "International Scholarship",
  scholarship_intl_desc: "For international students wishing to study at ESTAD.",
  scholarship_intl_criteria_1: "International student status",
  scholarship_intl_criteria_2: "French level B2 minimum",
  scholarship_intl_criteria_3: "Commitment to return to home country",
  scholarship_criteria: "Criteria",
  scholarship_process_badge: "Process",
  scholarship_process_title: "How to Apply",
  scholarship_step_1_title: "Check Eligibility",
  scholarship_step_1_desc: "Review the criteria for each scholarship and check your eligibility.",
  scholarship_step_2_title: "Prepare Application",
  scholarship_step_2_desc: "Gather required documents: transcripts, letters, supporting documents.",
  scholarship_step_3_title: "Interview",
  scholarship_step_3_desc: "If preselected, participate in an interview with the scholarship committee.",
  scholarship_step_4_title: "Decision",
  scholarship_step_4_desc: "Receive the decision notification by email within 2 weeks after the interview.",
  scholarship_faq_badge: "FAQ",
  scholarship_faq_title: "Frequently Asked Questions",
  scholarship_faq_1_q: "When can I apply for a scholarship?",
  scholarship_faq_1_a: "Applications open at the same time as admissions, generally in January of each academic year.",
  scholarship_faq_2_q: "Can I combine multiple scholarships?",
  scholarship_faq_2_a: "No, each student can only benefit from one scholarship at a time. The most advantageous amount is retained.",
  scholarship_faq_3_q: "Are scholarships renewable?",
  scholarship_faq_3_a: "Yes, provided you maintain a minimum average of 12/20 and comply with the internal regulations.",
  scholarship_faq_4_q: "How does the selection interview proceed?",
  scholarship_faq_4_a: "The interview lasts about 30 minutes and covers your background, motivations, and professional project.",
  scholarship_cta_title: "Apply Now",
  scholarship_cta_subtitle: "Scholarships are awarded based on merit and need. Don't miss the deadlines.",
  scholarship_cta_apply: "Apply Online",
  scholarship_cta_contact: "Contact the Scholarship Office",
};